import React from "react";

import { Avatar } from "../../wombat-ui";
import { AvatarProps } from "../../wombat-ui/components/Avatar/Avatar";

import { AvatarIcon } from "../../icons";

const UserAvatar: React.FC<Omit<AvatarProps, "fallback" | "ref">> = ({
  ...avatarProps
}) => (
  <Avatar
    fallback={AvatarIcon}
    fallbackClassName="w-full h-full text-dark-100"
    {...avatarProps}
  />
);

export default UserAvatar;
